"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotificationSeverity = exports.Label = exports.DefaultTitles = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireWildcard(require("../Button"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let Label = exports.Label = /*#__PURE__*/function (Label) {
  Label["Close"] = "Close notification";
  return Label;
}({});
const NotificationSeverity = exports.NotificationSeverity = {
  CAUTION: "caution",
  INFORMATION: "information",
  NEGATIVE: "negative",
  POSITIVE: "positive"
};
const DefaultTitles = exports.DefaultTitles = {
  [NotificationSeverity.CAUTION]: "Warning",
  [NotificationSeverity.INFORMATION]: "Info",
  [NotificationSeverity.NEGATIVE]: "Error",
  [NotificationSeverity.POSITIVE]: "Success"
};

/**
 * The props for the Notification component.
 */

/**
This is a [React](https://reactjs.org/) component for the Vanilla [Notification](https://docs.vanillaframework.io/patterns/notification/).

Notifications are used to display global information, our notification variants consist of default, caution, negative or positive.

The `NotificationProvider` component can be used to manage the notification state globally. Wrap your application components with it and then in any child component you can get the helper with `const notify = useNotify()` to easily trigger notifications:

* `notify.info("You should keep this in mind")`
* `notify.failure("Error when fooing a bar", errorObjectFromCatch)`
* `notify.success("The bar was foo'd", "Success")`

The `NotificationConsumer` component can be used to display notifications. It will automatically display any notifications that are added to the `NotificationProvider` state.

The Notification API has changed since v0.18 in order to support new variants
and align with our component prop naming conventions.

| Deprecated prop names | Replaced by |
| --------------------- | ----------- |
| `type`                | `severity`  |
| `status`              | `title`     |
| `close`               | `onDismiss` |

The `notificationTypes` const has also been replaced with `NotificationSeverity`
to reflect the new prop name.
 */
const Notification = _ref => {
  let {
    actions,
    borderless = false,
    children,
    className,
    close,
    inline = false,
    onDismiss,
    severity = NotificationSeverity.INFORMATION,
    status,
    timeout,
    timestamp,
    title,
    titleElement: TitleComponent = "h5",
    type,
    ...props
  } = _ref;
  const timeoutId = (0, _react.useRef)(null);
  const hasActions = (actions === null || actions === void 0 ? void 0 : actions.length) > 0;
  const showMeta = !!timestamp || hasActions;
  (0, _react.useEffect)(() => {
    if (timeout && onDismiss) {
      timeoutId.current = setTimeout(() => onDismiss(), timeout);
    }
    return () => clearTimeout(timeoutId.current);
  }, [onDismiss, timeout]);
  if (_utils.IS_DEV && (close || status || type)) {
    console.warn("The Notification component is using deprecated props. Refer to the deprecated list for details: https://canonical.github.io/react-components/?path=/docs/notification--information#deprecated");
  }
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(className, {
      ["p-notification--".concat(severity)]: !!severity,
      "p-notification": !severity,
      "is-borderless": borderless,
      "is-inline": inline
    })
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "p-notification__content"
  }, title && /*#__PURE__*/_react.default.createElement(TitleComponent, {
    className: "p-notification__title",
    "data-testid": "notification-title"
  }, title), inline && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\u2002"), /*#__PURE__*/_react.default.createElement("p", {
    className: "p-notification__message"
  }, children), onDismiss && /*#__PURE__*/_react.default.createElement("button", {
    className: "p-notification__close",
    "data-testid": "notification-close-button",
    onClick: onDismiss
  }, Label.Close)), showMeta && /*#__PURE__*/_react.default.createElement("div", {
    className: "p-notification__meta",
    "data-testid": "notification-meta"
  }, timestamp && /*#__PURE__*/_react.default.createElement("span", {
    className: "p-notification__timestamp",
    "data-testid": "notification-timestamp"
  }, timestamp), hasActions ? /*#__PURE__*/_react.default.createElement("div", {
    className: "p-notification__actions"
  }, actions.map((action, i) => /*#__PURE__*/_react.default.createElement(_Button.default, {
    appearance: _Button.ButtonAppearance.LINK,
    className: "p-notification__action",
    "data-testid": "notification-action",
    key: "".concat(action.label, "-").concat(i),
    onClick: action.onClick
  }, action.label))) : null));
};
var _default = exports.default = Notification;